import ConfigApplicationSettings from '../config/application.config';
import ConfigDeviceSettings from '../config/device.config';

const loadDeviceAndApplicationSettings = () => {
  ConfigDeviceSettings.loadDeviceSpecificConfig();
  ConfigApplicationSettings.loadApplicationConfig();
};

export { loadDeviceAndApplicationSettings };
